import { apiService } from "@/common/api.service.js";
import axios from 'axios';
import { CSRF_TOKEN } from "@/common/csrf_token.js"

export default {
  // PDF reports list
  getAllPdfReports() {
    const endpoint = `/documents/pdf-reports`;
    return apiService(endpoint);
  },

  // ISO chapters
  getAllIsoChapters() {
    const endpoint = `/documents/iso-chapters/`;
    return apiService(endpoint);
  },

  // Create PDF Report
  async pdfReportCreate(payload) {
    const formData = new FormData();
    formData.append("site_code", payload.site_code);
    formData.append("project_number", payload.project_number);
    formData.append("pdf_report", payload.pdf_report);
    formData.append("iso_chapter", payload.iso_chapter);
    formData.append("author", payload.author);
    formData.append("document_title", payload.document_title);
    formData.append("filename", payload.filename);

    const res = await axios.post("/documents/pdf-report-create/", formData, {
      headers: { "Content-Type": undefined, "X-CSRFTOKEN": CSRF_TOKEN },
    });
    return res.data;
  },
};
